const violationCodeToText = (code, t) => {
  switch (code) {
    case 'LATE_CLOCK_IN':
      return t('presence_status.late');
    case 'EARLY_CLOCK_OUT':
      return t('presence_status.leaving_early');
    case 'NOT_CLOCK_OUT':
      return t('presence_status.not_clocked_out');
    case 'OUT_OF_LOCATION_RANGE':
      return t('presence_status.out_of_area');
    case 'NOT_VALID_LOCATION':
      return t('presence_status.invalid_location');
    case 'NOT_STREAM':
      return t('presence_status.not_live');
    default:
      return code;
  }
};

export default violationCodeToText;
